// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"355e90fd","238":"cbe5d198","347":"530e9d53","382":"73c39f83","385":"ed450f34"}[chunkId] + ".chunk.js";
};